module.exports = __webpack_public_path__ + "img/Veranza-15-min.1b21b302.jpg";